import React from 'react';
import Typography from '@ui/Typography';
import { Box } from '@mui/system';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import { ModelOptionProps } from './types';
import ModelOption from './ModelOption';
import { SampleRateSubOption } from '../hooks/useProjectVersion';

const SCRIPT_STUDIO_COPY: ModelOptionProps = {
  title: 'Caruso',
  icon: 'carusoLogomark',
  description:
    'Our fastest, most advanced model with Cues for emotional control and fine tuning.',
};

export interface ScriptStudioOptionProps
  extends Pick<ModelOptionProps, 'disabled' | 'active'> {
  options?: Array<SampleRateSubOption>;

  error?: boolean;
  isUpgrade?: boolean;
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > button': { zIndex: 1 },
    gap: theme.spacing(0.75),
  },
  inputContainer: {
    display: 'grid',
    width: theme.spacing(19),
    gap: 10,
    '& > button': {
      color: 'inherit !important',
      '& > span > *': { color: 'inherit' },
    },
  },
  disabled: { opacity: 0.5 },
}));

const ScriptStudioOption = ({ active, disabled }: ScriptStudioOptionProps) => {
  const { classes, cx } = useStyles();

  return (
    <ModelOption
      variant="secondary"
      disabled={disabled}
      active={active}
      {...SCRIPT_STUDIO_COPY}
      title={
        <Box className={classes.container}>
          <Box className={classes.titleContainer}>
            <Typography
              id="models-label"
              variant="pMd"
              component="h3"
              bold
              className={cx({ [classes.disabled]: disabled })}
            >
              {SCRIPT_STUDIO_COPY.title}
            </Typography>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
                padding: '4px 8px',
                backgroundColor: palette.mint_200,
                color: palette.mint_500,
                width: 'fit-content',
              }}
            >
              <Typography variant="pXs" bold uppercased color="gray_500">
                New look
              </Typography>
            </div>
          </Box>
        </Box>
      }
    />
  );
};

export default ScriptStudioOption;
